import React, { FC } from 'react';
import { Formik } from 'formik';
import {
  Modal,
  Title,
  Button,
  Form,
  Content,
  Text,
  Row,
  RadioField,
  RadioLabel,
  TitleRow,
} from './styles';
import { BusyModeModalProps } from './types';
import useConnect from './connect';

const BusyModeModal: FC<BusyModeModalProps> = ({
  brandId,
  integrationId,
  open,
  handleClose,
}) => {
  const {
    handleSubmit,
    initialValues,
    validationSchema,
    modalState,
    changeToNormal,
    changeToCustomConfirm,
    changeToCloseConfirm,
    handleRequestCustomPeriod,
    selectedBrand,
    selectedIntegration,
  } = useConnect(brandId, integrationId, handleClose);

  return (
    <Modal
      showClose={false}
      open={open}
      handleClose={() => (handleClose ? handleClose(false) : null)}
    >
      {modalState === 'normal' && (
        <>
          <TitleRow>
            <Title>Apply busy mode</Title>
            {selectedBrand && selectedIntegration && (
              <Text>{`Add busy hours to ${selectedIntegration.name.short} for ${selectedBrand.name}`}</Text>
            )}
          </TitleRow>
          <Formik
            onSubmit={handleSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
          >
            {() => (
              <Form noValidate>
                <Row>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <RadioLabel htmlFor="busy_hour">
                    <RadioField
                      id="busy_hour"
                      type="radio"
                      name="busy_mode"
                      value="hour"
                    />
                    Next 1 hour
                  </RadioLabel>
                </Row>
                <Row>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <RadioLabel htmlFor="busy_eod">
                    <RadioField
                      id="busy_eod"
                      type="radio"
                      name="busy_mode"
                      value="today_eod"
                    />
                    End of day
                  </RadioLabel>
                </Row>
                <Row>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <RadioLabel htmlFor="busy_tomorrow_eod">
                    <RadioField
                      id="busy_tomorrow_eod"
                      type="radio"
                      name="busy_mode"
                      value="tomorrow_eod"
                    />
                    End of tomorrow
                  </RadioLabel>
                </Row>
                <Row>
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <RadioLabel htmlFor="busy_custom">
                    <RadioField
                      id="busy_custom"
                      type="radio"
                      name="busy_mode"
                      value="custom"
                      onChange={changeToCustomConfirm}
                    />
                    Custom Period
                  </RadioLabel>
                </Row>
                <Row>
                  <Button type="submit">Apply Busy Mode</Button>
                </Row>
                <Row>
                  <Button
                    color="blank"
                    variant="hard-outlined"
                    onClick={() => (handleClose ? handleClose(false) : null)}
                  >
                    Cancel
                  </Button>
                </Row>
              </Form>
            )}
          </Formik>
        </>
      )}
      {modalState === 'custom-confirm' && (
        <Content>
          <Row>
            <Title>Apply busy mode</Title>
          </Row>
          <Row>
            <Text>
              You need to reach support via chat or text message to apply custom
              hours busy mode.
            </Text>
          </Row>
          <Row>
            <Button type="button" onClick={handleRequestCustomPeriod}>
              Ok, I understand
            </Button>
          </Row>
          <Row>
            <Button
              type="button"
              color="blank"
              variant="hard-outlined"
              onClick={changeToCloseConfirm}
            >
              Close
            </Button>
          </Row>
        </Content>
      )}
      {modalState === 'close-confirm' && (
        <Content>
          <Row>
            <Title>Are you sure?</Title>
          </Row>
          <Row>
            <Text>Your custom hours busy mode won’t be applied.</Text>
          </Row>
          <Row>
            <Button type="button" onClick={changeToNormal}>
              Ok
            </Button>
          </Row>
          <Row>
            <Button
              type="button"
              color="blank"
              variant="hard-outlined"
              onClick={() => (handleClose ? handleClose(false) : null)}
            >
              Close
            </Button>
          </Row>
        </Content>
      )}
    </Modal>
  );
};

export default BusyModeModal;
